<template>
  <div
    class="col-start-1 col-span-12 row-start-1 row-span-6 z-0">
    <Map ref="MapHistory" :poi="true" />
    <Sidebar>
      <SideDetailKapal />
    </Sidebar>
    <InfoHistoryKapal />
    <PopupMessage :message="message" :confirm="{ success: confirmSuccess }" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Map from './Map.vue'
import Sidebar from './Sidebar'
import SideDetailKapal from './SideDetailKapal.vue'
import InfoHistoryKapal from './InfoHistoryKapal.vue'
import PopupMessage from './PopupMessage.vue'

export default {
  name: 'History',
  components: {
    Map,
    Sidebar,
    SideDetailKapal,
    InfoHistoryKapal,
    PopupMessage
  },
  data: () => ({
    cachePoi: {
      kapal: null
    }
  }),
  computed: {
    ...mapGetters([
      'poi',
      'activeMenu',
      'message'
    ])
  },
  methods: {
    ...mapActions([
      'toInitHistory',
      'toHideSidebar',
      'toActiveMenu'
    ]),
    ...mapMutations([
      'setMapControl',
      'setHistories',
      'setPoi',
      'setPoiEnable'
    ]),
    confirmSuccess: function () {

    }
  },
  mounted: async function () {
    this.cachePoi.kapal = this.poi.kapal.enable

    if (this.cachePoi.kapal === 'AKTIF') {
      this.setPoiEnable({
        key: 'kapal',
        enable: 'TIDAK'
      })
    } else {
      this.cachePoi.kapal = null
    }

    await this.$refs.MapHistory.init()

    if (this.$route.query.transmitter &&
      this.$route.query.start &&
      this.$route.query.end) {
      this.setHistories({
        transmitter: this.$route.query.transmitter,
        start: this.$route.query.start,
        end: this.$route.query.end
      })
    }

    await this.toInitHistory()

    this.toHideSidebar()
    this.toActiveMenu({
      name: this.activeMenu
    })
  },
  unmounted: function () {
    if (this.cachePoi.kapal) {
      this.setPoiEnable({
        key: 'kapal',
        enable: this.cachePoi.kapal
      })
    }
  }
}
</script>
